import { Chip, Stack } from '@mui/material'
import { ActivityLevel, WasteContainerDto, WasteType } from '@services/dtos'
import { ActivityLevelLabels, WasteTypeLabels } from '@utils/constants'
import WasteStatusIcon from './WasteStatusIcon'

type Props = {
  container: WasteContainerDto
  showStatus?: boolean
}

export const WasteContainerTypeChip = ({ container }: Props) => (
  <Chip
      size="small"
      label={WasteTypeLabels[container.type]}
      color="info"
      variant="outlined"
      sx={
        container.type === WasteType.SOLID || container.type === WasteType.SHARPS
          ? { borderColor: '#996600', color: '#996600' }
          : {}
      }
    />
)

export const WasteContainerActivityLevelChip = ({ container }: Props) => (
  <Chip
    size="small"
    label={
      container.activityLevel === ActivityLevel.NONE
        ? 'Sans activité'
        : `Activité ${ActivityLevelLabels[container.activityLevel].toLowerCase()}`
    }
    color={
      container.activityLevel === ActivityLevel.HIGH
        ? 'error'
        : container.activityLevel === ActivityLevel.LOW
          ? 'warning'
          : 'default'
    }
    variant="outlined"
  />
)

const WasteContainerChips = ({ container, showStatus = false }: Props) => (
  <Stack direction="row" spacing={0.5} mt={0.5} alignItems="center">
    {showStatus && <WasteStatusIcon status={container.status} />}
    <WasteContainerTypeChip container={container} />
    <WasteContainerActivityLevelChip container={container} />
    {container.isInfectious && (
      <Chip
        size="small"
        label="DASRI"
        variant="outlined"
        sx={{ borderColor: '#cbb000ff', color: '#cbb000ff' }}
      />
    )}
  </Stack>
)

export default WasteContainerChips